module.exports = __webpack_public_path__ + "img/wechat02.ca3ff4c3.png";